import React, { useEffect, useState } from 'react';
import { STANDARD_IMAGE_PATH } from './../files/Constants';
import Button from './bper-button';
import MapService from './../utils/MapService';
import { parseRegionURL } from '../utils/Functions';

export default function Filter({
    makeSearchCounter,
    defaultSearchFilter,
    initialSearchFilter,
    categories,
    translations,
    defaultResultsNumber,
    updateSearch,
    place,
    zoom,
    bank,
    googleMapRef,
    configurations,
    groupId,
    setOpenFilter,
    currentRegionProvince,
    regions,
    updateFilter,
    mapRef
}) {
    const [resultsNumber, setResultsNumber] = useState(undefined);
    const [selectedFilter, setSelectedFilter] = useState(JSON.parse(localStorage.getItem("subsidiaries-filter")));/* useState(initialSearchFilter.category === undefined && makeSearchCounter === 0
        ? {
            category: defaultSearchFilter,
            services: []
        }
        : initialSearchFilter
    );*/

    useEffect(() => {
        /*
        initialSearchFilter.category === undefined && updateResults({
            category: defaultSearchFilter,
            services: []
        });*/
        updateResults(JSON.parse(localStorage.getItem("subsidiaries-filter")))
    }, []);

    const addService = (serviceId) => {
        let currentSelectedService = selectedFilter.services;
        if (!currentSelectedService.includes(serviceId)) {
            currentSelectedService.push(serviceId)
        } else {
            currentSelectedService = currentSelectedService.filter(item => item !== serviceId);
        }
        const obj = {
            category: selectedFilter.category,
            services: currentSelectedService
        }
        setSelectedFilter(obj);
        updateResults(obj);
    }

    const changeSelectedCategory = (categoryId) => {
        const newSelectedFilter = (parseInt(categoryId) !== parseInt(selectedFilter.category)) ? {
            services: [],
            category: categoryId
        } : selectedFilter;
        setSelectedFilter(newSelectedFilter);
        updateResults(newSelectedFilter);
        updateFilter(newSelectedFilter);
    };

    const deleteFilter = () => {
        const defaultFilterSelected = {
            category: defaultSearchFilter,
            services: []
        };
        //const defaultFilterSelected ={ category: undefined, services: [] }
        setSelectedFilter(defaultFilterSelected);
        updateResults(defaultFilterSelected);
        updateFilter(defaultFilterSelected);
        //updateSearch(defaultFilterSelected);
    };

    const handleUpdateSearch = () => {
        updateSearch(selectedFilter);
    };

    const updateResults = (filter) => {
        const searchType = localStorage.getItem("search-type");

        const numberOfResults = configurations.defaultLimitResults;
        let distance;

        if (place && currentRegionProvince && currentRegionProvince.region === "") {
            // 1) ricerca "normale"
            setResultsNumber(undefined);
            if (isFinite(zoom) && searchType === "here") {
                //SOLO se sto facendo "cerca qui"
                //cerco il "raggio". In pratica la distanza in metri tra il centro della map e il "top" della mappa.
                const mapHeight = googleMapRef.current.clientHeight;
                const metersPerPx = 156543.03392 * Math.cos(place.lat * Math.PI / 180) / Math.pow(2, zoom);
                //Info here: https://stackoverflow.com/questions/5939983/how-does-this-google-maps-zoom-level-calculation-work
                distance = mapHeight / 2 * metersPerPx;
            } else {
                if (searchType === "all") {
                    distance = undefined;
                } else {
                    let zoom = undefined;
                    if (searchType === "geo") {
                        zoom = configurations.defaultZoomLevelGeo;//apiData.mapRef?.current?.getZoom();
                    } else {
                        zoom = mapRef?.current?.getZoom();
                    }
                    const mapHeight = googleMapRef.current.clientHeight;
                    const metersPerPx = 156543.03392 * Math.cos(place.lat * Math.PI / 180) / Math.pow(2, zoom);
                    //Info here: https://stackoverflow.com/questions/5939983/how-does-this-google-maps-zoom-level-calculation-work
                    distance = mapHeight / 2 * metersPerPx;

                }
            }

            MapService.getResultsNumber(bank, (filter ? filter : selectedFilter), place, zoom, numberOfResults, distance, groupId).then((response) => {
                (response && response.data && response.data.payload && response.data.payload.countResult)
                    ? setResultsNumber(response?.data.payload.countResult)
                    : setResultsNumber(undefined);
            });

        } else {
            // 2) sto cercando per regione/provincia
            setResultsNumber(undefined);

            const otherCategories = (filter ? filter : selectedFilter);
            let categories = [];
            if (currentRegionProvince.region && currentRegionProvince.region !== "") {
                const currentRegionObj = regions.filter(el => parseRegionURL(el.categoryDescription) === parseRegionURL(currentRegionProvince.region));
                const currentRegionId = currentRegionObj && currentRegionObj[0] && currentRegionObj[0].categoryId;
                currentRegionId && categories.push(currentRegionId);

                if (currentRegionObj && currentRegionObj[0] && currentRegionProvince.province && currentRegionProvince.province !== "") {
                    const currentProvinceObj = currentRegionObj[0].subFilters.filter(a => parseRegionURL(a.categoryDescription) === parseRegionURL(currentRegionProvince.province))
                    const currentProvinceId = currentProvinceObj && currentProvinceObj[0] && currentProvinceObj[0].categoryId;
                    currentProvinceId && categories.push(currentProvinceId);
                }
            }

            if (otherCategories) {
                const filterCategory = otherCategories.category;
                const filterServices = otherCategories.services;
                let services = filterCategory ? [filterCategory] : [];
                if (filterServices !== undefined) {
                    filterServices.forEach((el) => (services.push(el)));
                }
                categories = categories.concat(services);
            }

            try {
                MapService.getRegionSubsidiary(groupId, bank, categories).then((response) => {
                    const loc = response.data.payload.subsidiaryListGeoloc;
                    loc && loc.length && setResultsNumber(loc.length);
                })
            } catch (err) {
                console.error("Errore", err);
            };
        }
    }

    const selectedCategoryObject =
        selectedFilter &&
        categories.filter((el) => el.categoryId === selectedFilter.category);
    const selectedCategoryServices = selectedCategoryObject?.[0]?.subFilters;

    const showButtons = (selectedFilter && selectedFilter.category && selectedCategoryServices && selectedFilter.services.length > 0) ?
        true
        :
        (selectedFilter && selectedFilter.category && selectedCategoryServices === undefined)
            ? true
            : selectedFilter.services.length > 0
                ? true
                : false;

    const selectedCategoryIsSubfilters = ((selectedFilter && selectedFilter.category !== undefined) && selectedCategoryServices && selectedCategoryServices[0] && selectedCategoryServices[0].subFilters !== undefined) ? true : false;

    return (
        <div className="filter-wrapper-content">
            <a className="close-filters-mobile"
                onClick={() => setOpenFilter(false)}>
                {translations.closeButton && translations.closeButton !== "" && <span className="label">{translations.closeButton}</span>}
                <svg id="close-circle" className="close-circle" data-name="close-circle" xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 60 60">
                    <g id="Rectangle" fill="none" stroke="#006369" stroke-miterlimit="10" strokeWidth="1">
                        <rect width="60" height="60" rx="30" stroke="none" />
                        <rect x="0.5" y="0.5" width="59" height="59" rx="29.5" fill="none" />
                    </g>
                    <g id="Group_2" data-name="Group 2" transform="translate(24 24)">
                        <path id="Path_2" data-name="Path 2" d="M0,12,12,0" fill="none" stroke="#006369" stroke-linecap="round" stroke-miterlimit="10" strokeWidth="2" />
                        <path id="Path_2-2" data-name="Path 2" d="M12,12,0,0" fill="none" stroke="#006369" stroke-linecap="round" stroke-miterlimit="10" strokeWidth="2" />
                    </g>
                </svg>
            </a>
            <div className="filter">
                {categories && (
                    <div className="categories">
                        <div className="categories-with-image">
                            <h3>{translations.filter_title_1}</h3>
                            <ul>
                                {categories.map((el) => (
                                    <li
                                        key={el.categoryId}
                                        onClick={() =>
                                            changeSelectedCategory(el.categoryId)
                                        }

                                        className={
                                            selectedFilter &&
                                                selectedFilter.category ===
                                                el.categoryId
                                                ? 'selected'
                                                : ''
                                        }
                                    >
                                        <div className="img">
                                            {el.categoryIconPath &&
                                                el.categoryIconPath != '' ? (
                                                    <img src={el.categoryIconPath} alt={el.categoryDescription} />
                                                ) : (
                                                    <img src={STANDARD_IMAGE_PATH} alt={el.categoryDescription} />
                                                )}
                                        </div>
                                        <h4>{el.categoryDescription}</h4>
                                    </li>
                                ))}
                            </ul>
                        </div>
                        {selectedCategoryServices && (
                            <div className="services">
                                <h3>{translations.filter_title_2}</h3>
                                {
                                    selectedCategoryIsSubfilters
                                        ?
                                        <>
                                            {selectedCategoryServices.map(item =>
                                                <>
                                                    <div key={item.categoryId}>
                                                        {item.categoryDescription &&
                                                            <h4>{item.categoryDescription}</h4>
                                                        }
                                                        {item.subFilters &&
                                                            <ul>
                                                                {item.subFilters.map(
                                                                    (service) => (
                                                                        <li
                                                                            key={service.categoryId}
                                                                            className={
                                                                                selectedFilter.services.includes(
                                                                                    service.categoryId
                                                                                )
                                                                                    ? 'selected token'
                                                                                    : 'token'
                                                                            }
                                                                            data-id={service.categoryId}
                                                                            onClick={() =>
                                                                                addService(
                                                                                    service.categoryId
                                                                                )
                                                                            }
                                                                        >
                                                                            <span>
                                                                                {service.categoryDescription}
                                                                            </span>
                                                                        </li>
                                                                    )
                                                                )}
                                                            </ul>
                                                        }
                                                    </div>
                                                </>
                                            )}
                                        </>
                                        :
                                        <>
                                            <ul>
                                                {selectedCategoryServices.map(item =>

                                                    <li
                                                        key={item.categoryId}
                                                        className={
                                                            selectedFilter.services.includes(
                                                                item.categoryId
                                                            )
                                                                ? 'selected token'
                                                                : 'token'
                                                        }
                                                        data-id={item.categoryId}
                                                        onClick={() =>
                                                            addService(
                                                                item.categoryId
                                                            )
                                                        }
                                                    >
                                                        <span>
                                                            {item.categoryDescription}
                                                        </span>
                                                    </li>
                                                )}
                                            </ul>
                                        </>
                                }
                            </div>
                        )}
                    </div>
                )}
                <div className="footer-wrapper">
                    <i className="results">{resultsNumber > 0 ? resultsNumber : "0"}&nbsp;{resultsNumber === 1 ? translations.resultLabel : translations.resultsLabel}</i>
                    <div className="buttons">
                        {
                            showButtons ? (
                                <>
                                    <Button onClick={() => deleteFilter()}>
                                        {translations.buttonDeleteFilter}
                                    </Button>
                                    {/*
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={handleUpdateSearch}
                                    >
                                        {translations.buttonShow}
                                    </Button>
                                    */}
                                </>
                            ) : (
                                    <>
                                        {/*
                                        <Button
                                            disabled={true}
                                            variant="contained"
                                            color="primary"
                                            onClick={handleUpdateSearch}
                                        >
                                            {translations.buttonShow}
                                        </Button>
                                    */}
                                    </>
                                )
                        }
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={handleUpdateSearch}
                        >
                            {translations.buttonShow}
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
}
